<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        :color="statusColor(vehicleStatusValue)"
        size="20"
        v-bind="attrs"
        v-on="on"
      >
      </v-avatar>
    </template>
    <span>{{ vehicleStatusValue || 'Unknown' }}</span>
  </v-tooltip>
</template>

<script>
  import { getColor } from '@/utils'
  import { mapGetters } from "vuex"

  export default {
    props: {
      vehicle: {
        type: [String, Boolean],
        default: () => 'none'
      },
      // sometimes we might want to jsut directly pass in the status, rather than the vehicle id if we already have it
      status: {
        default: () => ''
      }
    },

    computed: {
      ...mapGetters('presence', [
				'vehicleStatus'
			]),

      // if the status was inserted directly, we rely on that instead of vehicle look ups
      vehicleStatusValue () {
        return this.status
          ? this.status
          : this.vehicleStatus[this.vehicle]
      }
    },

    methods: {
      statusColor(status) {
        return getColor(status)
      },
    }  
  }
</script>